import React from 'react'

function Support() {
    return (
        <>
            <div class="support section">
      <div class="container">
        <div class="row">
         <div class="support-inner">
          <div class="col-md-4 col-sm-4 col-xs-12">
            <div class="row-normal clearfix">
              <div class="support-info">
                <div class="info-title">
                  <i class="icon-plane"></i>
                  Free Shipping Worldwide
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-12">
            <div class="row-normal clearfix">
              <div class="support-info">
                <div class="info-title">
                  <i class="icon-earphones-alt"></i>
                  24/7 Customer Service
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-12">
            <div class="row-normal clearfix">
              <div class="support-info">
                <div class="info-title">
                  <i class="icon-refresh"></i>
                  Easy Return Policy
                </div>
              </div>
            </div>
          </div>
         </div>
        </div>
      </div>
    </div>
        </>
    )
}

export default Support
